import React from "react"

import { NgrInputs } from "services/total/types"

import { formatFiatCurrency } from "util/formatter"

import { buildNgrRows } from "./buildNgrRows"

interface Props {
  inputs?: NgrInputs
  wager?: number
  win?: number
}

export function NgrTooltipContent({ inputs, wager, win }: Props) {
  if (!inputs) {
    return (
      <div className="space-y-2">
        <div className="font-semibold">How NGR is calculated</div>
        <div>NGR = GGR - (Bonus - CancelledBonus) - (GGR × 0.07) - PositiveGgrFees - (Deposits × 0.085) - (Withdrawals × 0.04)</div>
        <div className="opacity-70">No inputs provided by backend.</div>
      </div>
    )
  }

  const rows = buildNgrRows({ inputs, wager, win })

  return (
    <div className="space-y-2 z-[9999]">
      <div className="font-semibold">How NGR is calculated</div>

      <div className="opacity-90">
        NGR = GGR - (Bonus - CancelledBonus) - (GGR × 0.07) - PositiveGgrFees - (Deposits × 0.085) - (Withdrawals × 0.04)
      </div>

      <div className="border-t border-[rgba(255,255,255,0.12)] pt-2 space-y-1">
        {rows.map((row) => (
          <div key={row.label}>
            <div className="flex justify-between gap-4">
              <span>
                {row.label} {row.note && <span className="opacity-60 ml-1">({row.note})</span>}
              </span>
              <span className="font-mono flex gap-2">
                {row.struckValue && <span className="line-through opacity-50">{formatFiatCurrency(String(row.struckValue))}</span>}
                <span>{formatFiatCurrency(String(row.value))}</span>
              </span>
            </div>

            {row.children && (
              <div className="flex flex-col gap-2 pl-4 mt-1">
                {row.children.map((child) => (
                  <div className="flex justify-between gap-4" key={child.label}>
                    <span>{child.label}</span>
                    <span className="font-mono">{formatFiatCurrency(String(child.value))}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
